import React, { ChangeEvent, FC, FormEvent, HTMLInputTypeAttribute, } from "react"
import "./../../../assets/scss/widgets/input.scss"
interface RoundedInputProps extends React.HTMLProps<HTMLInputElement> {
    onChange?: (e: ChangeEvent<HTMLInputElement>) => any
}

export class RoundedInput extends React.Component<RoundedInputProps> {
    render() {
        return (
            <div className={`rounded-input ${this.props.disabled ? 'disabled' : ''}`}>
                <input {...this.props}/>
            </div>
        )
    }
    
}

export default RoundedInput;